import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment as env } from '@environments/environment';
import { NotFoundComponent } from '@views/pages/not-found/not-found.component';
import { AppRoutingModule as VerifRoutingModule } from 'projects/verifica-autenticidade/src/app/app-routing.module';
import { authGuard, portalGuard } from './auth';
import { HomeComponent } from './core/home/home/home.component';

const routes: Routes = [
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    { path: 'login', pathMatch: 'full', redirectTo: 'auth' }, // Backward compatibility
    {
        path: 'auth',
        loadChildren: () =>
            import('./auth/auth.module').then(m => m.AuthModule),
    },
    {
        path: 'pages',
        loadChildren: () =>
            import('@views/pages/pages.module').then(m => m.PagesModule),
    },

    {
        path: 'publico',
        loadChildren: () =>
            import('@views/portal-publico/portal-publico.module').then(
                m => m.PortalPublicoModule
            ),
    },
    {
        path: '',
        component: HomeComponent,
        children: [
            {
                path: 'colaborador',
                canActivate: [authGuard],
                loadChildren: () =>
                    import(
                        './portal-colaborador/portal-colaborador.module'
                    ).then(m => m.PortalColaboradorModule),
            },
            {
                path: 'administrador',
                canActivate: [authGuard, portalGuard],
                data: {
                    portal: 'Administrador',
                },
                loadChildren: () =>
                    import(
                        './portal-administrador/portal-administrador.module'
                    ).then(m => m.PortalAdministradorModule),
            },
            {
                path: 'coordenador',
                canActivate: [authGuard, portalGuard],
                data: {
                    portal: 'Coordenador',
                },
                loadChildren: () =>
                    import(
                        './portal-coordenador/portal-coordenador.module'
                    ).then(m => m.PortalCoordenadorModule),
            },
            {
                path: 'gestor',
                canActivate: [authGuard, portalGuard],
                data: {
                    portal: 'Gestor',
                },
                loadChildren: () =>
                    import('./portal-gestor/portal-gestor.module').then(
                        m => m.PortalGestorModule
                    ),
            },
        ],
    },
    {
        path: '403',
        redirectTo: '/pages/access-denied',
    },
    {
        path: '404',
        redirectTo: '/pages/not-found',
    },
    {
        path: 'access-denied',
        redirectTo: '/pages/access-denied',
    },
    {
        path: 'projetos',
        loadChildren: () =>
            import('./modules/projetos/projetos.module').then(
                m => m.ProjetosModule
            ),
    },

    {
        path: 'orcamento',
        title: `${env.titlePrefix} Orcamento`,
        loadChildren: () =>
            import('./modules/orcamento/orcamento.module').then(
                m => m.OrcamentoModule
            ),
    },
    {
        path: 'documentos',
        title: `${env.titlePrefix} Documentos`,
        loadChildren: () =>
            import('./modules/documentos/documentos.module').then(
                m => m.DocumentosModule
            ),
    },
    {
        path: 'requisicoes',
        title: `${env.titlePrefix} Requisições`,
        loadChildren: () =>
            import('./modules/requisicoes/requisicoes.module').then(
                m => m.RequisicoesModule
            ),
    },

    {
        path: '**',
        component: NotFoundComponent,
    },
];

@NgModule({
    imports: [VerifRoutingModule, RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
